import { useMemo } from 'react';

const useIsLoading = ( { items = [] } ) => {
    
    const isLoading = useMemo( () => {
        return items.find( i => i === true ) || false;
    }, [ items ] );

    return useMemo( () => {
        return {
            isLoading
        };
    }, [ isLoading ] );
};

export default useIsLoading;
